Controller.$inject = [];

function Controller() {
    const self = this;

    const FIRST_CELL_TABLE_WIDTH = 350;
    const TABLE_CELL_WIDTH = 166;
    const FIRST_CELL_SKELETON_WIDTH = 300;
    const SKELETON_CELL_WIDTH = 144;

    
    self.getRowsArray = () => {
        return Array.from({length: self.rows}, (_, i) => i);
    };
    
    self.getColumnsArray = () => {
        return Array.from({length: self.columns}, (_, i) => i);
    };
    
    self.getColumnWidth = (columnIndex) => {
        return columnIndex === 0 ? FIRST_CELL_TABLE_WIDTH + 'px' : TABLE_CELL_WIDTH + 'px';
    };
    
    self.getSkeletonWidth = (columnIndex) => {
        return columnIndex === 0 ? FIRST_CELL_SKELETON_WIDTH : SKELETON_CELL_WIDTH;
    };

    self.$onInit = () => {
        self.rows = self.rows || 5;
        self.columns = self.columns || 7;
    };
}

export function HuiTableSkeleton() {
    return {
        restrict: 'E',
        replace: false,
        scope: true,
        bindToController: {
            rows: '<',
            columns: '<'
        },
        transclude: true,
        controller: Controller,
        controllerAs: '$huiCtrl',
        template: ($element, $attrs) => {
            return `
      <hui-table-container>                
         <hui-table>
            <hui-thead>
                <hui-tr>
                    <hui-cell as="th" 
                              ng-repeat="column in $huiCtrl.getColumnsArray(); track by $index"
                              ng-style="{'width': $huiCtrl.getColumnWidth($index)}">
                        <hui-skeleton width="{{$huiCtrl.getSkeletonWidth($index)}}" height="20"></hui-skeleton>
                    </hui-cell>
                </hui-tr>
            </hui-thead>
            <hui-tbody>
                <hui-tr ng-repeat="row in $huiCtrl.getRowsArray(); track by $index">
                    <hui-cell ng-repeat="column in $huiCtrl.getColumnsArray(); track by $index">
                        <hui-skeleton width="{{$huiCtrl.getSkeletonWidth($index)}}" height="20"></hui-skeleton>
                    </hui-cell>
                </hui-tr>
            </hui-tbody>
        </hui-table>
     </hui-table-container>
        `;
        }
    }
}